import React from "react";

export const ReactNativeIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="30"
    viewBox="0 0 34 30"
    fill="none"
  >
    <g clipPath="url(#clip0_12751_8384)">
      <path
        d="M17 17.6216C18.6245 17.6216 19.9413 16.3048 19.9413 14.6803C19.9413 13.0559 18.6245 11.739 17 11.739C15.3756 11.739 14.0587 13.0559 14.0587 14.6803C14.0587 16.3048 15.3756 17.6216 17 17.6216Z"
        fill="black"
      />
      <path
        d="M17 20.7062C25.7165 20.7062 32.7826 18.0083 32.7826 14.6801C32.7826 11.352 25.7165 8.65405 17 8.65405C8.28352 8.65405 1.21741 11.352 1.21741 14.6801C1.21741 18.0083 8.28352 20.7062 17 20.7062Z"
        stroke="black"
      />
      <path
        d="M11.7813 17.6932C16.1396 25.242 22.0091 30.0124 24.8914 28.3483C27.7736 26.6843 26.5771 19.2159 22.2188 11.6672C17.8606 4.11846 11.991 -0.651991 9.10877 1.01207C6.22654 2.67613 7.42308 10.1445 11.7813 17.6932Z"
        stroke="black"
      />
      <path
        d="M11.7813 11.6672C7.42307 19.2159 6.22652 26.6843 9.10876 28.3484C11.991 30.0124 17.8606 25.242 22.2188 17.6933C26.5771 10.1446 27.7736 2.67616 24.8914 1.0121C22.0091 -0.651955 16.1396 4.11849 11.7813 11.6672Z"
        stroke="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_12751_8384">
        <rect
          width="33"
          height="29.3606"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
